module.exports = __webpack_public_path__ + "img/Honigloeffel-v2-400.3c9c8125.png";